module.exports = __webpack_public_path__ + "static/foundingchild_possum_square-2ddae9e9ecd7be74883fdec9ebe2f56c.jpg";